import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import VoteList from './components/VoteList';

const { Cell } = ResponsiveGrid;

const Vote = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="投票列表"
        // description="投票列表"
        breadcrumbs={[
          {
            name: '投票活動',
          },
          {
            name: '投票列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <VoteList />
    </Cell>
  </ResponsiveGrid>
);

export default Vote;
